export default __webpack_public_path__ + "static/media/logo.c6577379.png";